import * as types from './mutation-types.js'

export const loadRooms = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('/get/rooms').then((response) => {
            commit(types.ADD_ROOMS, response.data.data)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const loadRestaurantRooms = ({ commit, dispatch, state }, restaurant_id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/restaurant/${restaurant_id}/rooms`).then((response) => {
            commit(types.LOAD_ROOMS, response.data.data)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const loadRoom = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`show/${id}/room`).then((response) => {
            commit(types.LOAD_ROOM, response.data.data)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const storeRoom = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('/store/room', data).then((response) => {
            commit(types.ADD_ROOM, response.data.data)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}